/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslations } from 'next-intl';
import Tag from './Tag';
import studioStore from '@/stores/studioStore';

function Tags({ product, side = "reverse", size = "small", className = "" }) {
  const t = useTranslations('Product');

  let classes = `tags flex w-full md:pb-2 md:min-h-[2.4rem] ${className}`;

  if (side == "reverse") {
    classes = classes + " flex-row-reverse";
  }

  return (
    <div className={classes}>
      {product.on_sale && (
        <Tag additionalClasses="sale-tag" bgColor={studioStore?.settings?.colors?.secondary_color} size={size}>
          {t('sale')}
        </Tag>
      )}
      {product?.tags.map(tag => (
        <Tag key={tag.id} bgColor={tag.bg_color} textColor={tag.text_color} size={size}>
          {tag.name}
        </Tag>
      ))}
    </div>
  );
}

export default Tags;
